import React, { Component } from 'react';
import Button from '../../../components/form/Button';
import { push } from 'react-router-redux';
import { noop } from 'lodash';
import { styles } from '../index';
import InfoMessage from './InfoMessage';

export default (Comp) => (
  class AskActionComponent extends Component {
    state = {
      text: 'Opravdu chcete smazat tento objekt?',
      showNote: false,
      action: noop,
    }

    onAsk = (action, text = this.state.text, showNote = false) => () => {
          this.setState({ text, action, showNote, note: '' })
      this.props.dispatch(push({ pathname: window.location.pathname, query: { q: 'smazat' } }))
    }

    doAction = async () => {
      await this.state.action(this.state.note)
      if (this.refs.askComponent && window.location.search.includes('q=smazat') && !this.state.showNote) { // in case component is already unmounted or action navigated away
        this.back()
      }
    }

    back = () => {
      this.props.router.goBack();
    }

      questionStyle = show => show ? { color: '#000' } : { display: 'none' }

    render() {
      const { location: { query } } = this.props;
      const { text, showNote, note } = this.state;

      const show = query.q === 'smazat';
      return (
        <div ref="askComponent">
          <div style={this.questionStyle(!show)}>
            <Comp {...this.props} askAction={this.onAsk} />
          </div>

          <div style={this.questionStyle(show)}>
            <InfoMessage variant="warning">{text}</InfoMessage>
            {showNote && (
                <div style={{ marginBottom: 16 }}>
                    <label>Důvod smazání (nepovinné):</label>
                    <textarea
                        value={note}
                        onChange={(e) => this.setState({ note: e.target.value })}
                        rows={3}
                        style={{ width: '100%', marginTop: 8, padding: 8 }}
                    />
                </div>
            )}
            <Button type="button" style={{ ...styles.buttons, marginRight: 8 }} label="Potvrdit" onClick={this.doAction} />
            <Button type="button" style={styles.buttons} label="Zpět" onClick={this.back} />
          </div>
        </div>
      )
    }
  }
)
